export const getUpdatedPropertySyndication = (
  propertySyndication,
  channelUpdates
) => {
  const updatedPropertySyndication = {
    ...propertySyndication,
    ...channelUpdates,
  };

  const { property, ...channels } = updatedPropertySyndication;
  const activeCount = Object.values(channels).filter(Boolean).length;

  property.activeChannelCount = activeCount;

  return updatedPropertySyndication;
};
